module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/product-images/fr-product-05-7788d2b21acf7925c532535867ef5ee5.jpg";